import React, { createContext } from 'react';
import http from '../utils/httpFacade';
import { useToggle, useLockBodyScroll } from 'react-use';

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [bankDetails, setBankDetails] = useToggle(false);
  const [personalDetails, setPersonalDetails] = useToggle(false);
  const [walletBankDetails, setWalletBankDetails] = useToggle(false);

  useLockBodyScroll(bankDetails);
  useLockBodyScroll(personalDetails);
  useLockBodyScroll(walletBankDetails);

  const getProfile = async () => {
    try {
      return await http.get({ url: 'users/profile' });
    } catch (error) {
      return error;
    }
  };

  const updateProfile = async body => {
    try {
      return await http.patch({ url: 'users/profile', body });
    } catch (error) {
      return error;
    }
  };

  const fetchNotifications = async () => {
    try {
      return await http.get({ url: 'users/notifications' });
    } catch (error) {
      return error;
    }
  };

  const postBankDetails = async data => {
    try {
      return await http.post({
        url: 'crowd-farmer/bank',
        body: JSON.stringify(data)
      });
    } catch (error) {
      return error;
    }
  };

  const getBankDetails = async () => {
    try {
      return await http.get({ url: 'crowd-farmer/bank' });
    } catch (error) {
      return error;
    }
  };

  const patchBankDetails = async () => {
    try {
      return await http.patch({ url: 'crowd-farmer/bank' });
    } catch (error) {
      return error;
    }
  };

  const postIdentification = async image => {
    try {
      return await http.post({
        url: 'crowd-farmer/identity',
        body: JSON.stringify(image)
      });
    } catch (error) {
      return error;
    }
  };

  const getIdentification = async () => {
    try {
      return await http.get({ url: 'crowd-farmer/identity' });
    } catch (error) {
      return error;
    }
  };

  const patchIdentification = async () => {
    try {
      return await http.patch({ url: 'crowd-farmer/identity' });
    } catch (error) {
      return error.data;
    }
  };

  const handleBankDetailsModal = () => {
    setBankDetails(!bankDetails);
  };

  const handlePersonalDetailsModal = () => {
    setPersonalDetails(!personalDetails);
  };

  const handleWalletBankDetailsModal = () => {
    setWalletBankDetails(!walletBankDetails);
  };

  return (
    <UserContext.Provider
      value={{
        getProfile,
        updateProfile,
        fetchNotifications,
        postBankDetails,
        getBankDetails,
        patchBankDetails,
        postIdentification,
        getIdentification,
        patchIdentification,
        handleBankDetailsModal,
        handlePersonalDetailsModal,
        handleWalletBankDetailsModal,
        bankDetails,
        personalDetails,
        walletBankDetails
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
